/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_Digital_TemplateInputs */

const en_listing_category_digital_template = /** @type {(inputs: Listing_Category_Digital_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Templates`)
};

const es_listing_category_digital_template = /** @type {(inputs: Listing_Category_Digital_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantillas`)
};

const fr_listing_category_digital_template = /** @type {(inputs: Listing_Category_Digital_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modèles`)
};

const de_listing_category_digital_template = /** @type {(inputs: Listing_Category_Digital_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlagen`)
};

const ja_listing_category_digital_template = /** @type {(inputs: Listing_Category_Digital_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テンプレート`)
};

const zh_listing_category_digital_template = /** @type {(inputs: Listing_Category_Digital_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`模板`)
};

const ar_listing_category_digital_template = /** @type {(inputs: Listing_Category_Digital_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قوالب`)
};

const id_listing_category_digital_template = /** @type {(inputs: Listing_Category_Digital_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Templat`)
};

const it_listing_category_digital_template = /** @type {(inputs: Listing_Category_Digital_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelli`)
};

const ru_listing_category_digital_template = /** @type {(inputs: Listing_Category_Digital_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Шаблоны`)
};

const pt_listing_category_digital_template = /** @type {(inputs: Listing_Category_Digital_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Templates`)
};

const ko_listing_category_digital_template = /** @type {(inputs: Listing_Category_Digital_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`템플릿`)
};

/**
* | output |
* | --- |
* | "Templates" |
*
* @param {Listing_Category_Digital_TemplateInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_digital_template = /** @type {((inputs?: Listing_Category_Digital_TemplateInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_Digital_TemplateInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_digital_template(inputs)
	if (locale === "es") return es_listing_category_digital_template(inputs)
	if (locale === "fr") return fr_listing_category_digital_template(inputs)
	if (locale === "de") return de_listing_category_digital_template(inputs)
	if (locale === "ja") return ja_listing_category_digital_template(inputs)
	if (locale === "zh") return zh_listing_category_digital_template(inputs)
	if (locale === "ar") return ar_listing_category_digital_template(inputs)
	if (locale === "id") return id_listing_category_digital_template(inputs)
	if (locale === "it") return it_listing_category_digital_template(inputs)
	if (locale === "ru") return ru_listing_category_digital_template(inputs)
	if (locale === "pt") return pt_listing_category_digital_template(inputs)
	return ko_listing_category_digital_template(inputs)
});